import React from 'react'

export const AccountMenu = ({functionBtn}) => {
    return (
        <div className='mpage-dto content '>
            <div className="mp-btn-container">

                <h4 className="mp-header-nav-title">Más Información de Contacto</h4>

                <button className="mpage-btn"
                 data-id="2"
                 onClick={functionBtn}
                 >

                    <span className="material-symbols-outlined notranslate mI-modal-buttons mI-color" aria-hidden="true" role="none">person</span>

                    <p className="mp-p">Datos de Contacto</p>

                </button>

                <button 
                className="mpage-btn"
                data-id="3"
                onClick={functionBtn}>

                    <span className="material-symbols-outlined notranslate mI-modal-buttons mI-color" aria-hidden="true" role="none">
                        deployed_code</span>

                    <p className="mp-p">Envío de Kit</p>

                </button>

                <button
                className="mpage-btn"
                data-id="4"
                onClick={functionBtn}>

                    <span className="material-symbols-outlined notranslate mI-modal-buttons mI-color" aria-hidden="true" role="none">id_card</span>

                    <p className="mp-p">Suscripciones</p>

                </button>

                <button 
                className="mpage-btn"
                data-id="5"
                 onClick={functionBtn}>

                    <span className="material-symbols-outlined notranslate mI-modal-buttons mI-color" aria-hidden="true" role="none">info</span>

                    <p className="mp-p">Mas Información</p>

                </button>
            </div>
        </div>
    )
}
